import { CSSProperties, Dispatch, SetStateAction } from "react";
import { GenericRow } from "../../Tables/_Tables/useColumnConstructor";
import { colors, glyphs } from "../../../Styles";
import { FeedCurve, FeedPlanEntry } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { Button } from "../../BaseComponents";
import { ButtonTypes } from "../../../Definitions";

export interface feedCurveSpreadingRow extends GenericRow {
  id: number;
  milestoneName: string;
  milestoneSpreading?: boolean;
  milestoneFirstDay: number;
  newDay: boolean;
  total: number;
  feedCurveMilestoneId: number;
  milestoneId: number;
  milestoneIndex: number;
  milestoneArrayIndex: number;
  addDay: JSX.Element;
}

export const convertMinutesToTime = (minutes: number): string => {
  return `${Math.floor(minutes / 60)}:${(minutes % 60).toString().padStart(2, "0")}`
}

export const divStyleOverride = (value?: string | number): CSSProperties | undefined => {
    if (value === undefined) return undefined;
    const numericValue = typeof value === "number" ? value : parseFloat(value);
    return { color: numericValue === 100 ? colors.systemGreen : colors.systemRed };
  }

export const convertFeedCurveToSpreadingData = (feedCurve: FeedCurve, feedPlans: FeedPlanEntry[][], setFeedPlans: Dispatch<SetStateAction<FeedPlanEntry[][]>>) => {
  const sparseFeedTimesData: Map<number, feedCurveSpreadingRow> = new Map();
  if (!feedCurve || !feedCurve.milestones) return sparseFeedTimesData;
  
  let firstDayOffsetTracker = 0;
  [...feedCurve.milestones].sort((milestoneA, milestoneB) => (milestoneA.milestoneIndex - milestoneB.milestoneIndex))
    .forEach((milestone, indexMilestone) => {
      if (milestone.feedPlan === undefined) {
        return
      }
      const feedDays = [...milestone.feedDays].sort((dayA, dayB) => dayA.day - dayB.day); 
      if ( indexMilestone === 0 ) {
        firstDayOffsetTracker =  (feedDays && feedDays[0]) ? feedDays[0].day : 0;
      } 
      if(!feedPlans[indexMilestone]) {
        return
      }
      feedPlans[indexMilestone].forEach((timesDay, indexFeedPlan, array) => {
        const day = timesDay.day + firstDayOffsetTracker
        const previousValues = sparseFeedTimesData.get(day);
        if (previousValues) {
          sparseFeedTimesData.set(day, {...previousValues, newDay: previousValues.newDay && (timesDay.feedPlanEntryId < 0) ? true : false, [timesDay.timeId]: timesDay.amount, total: previousValues.total + (timesDay.amount) });
          return;
        } 
        sparseFeedTimesData.set(day, {
          [timesDay.timeId]: timesDay.amount,
          id: day,
          newDay: timesDay.feedPlanEntryId < 0 ? true: false, 
          milestoneName: indexFeedPlan === 0 ? milestone.name : "",
          milestoneArrayIndex: indexMilestone,
          milestoneFirstDay: firstDayOffsetTracker,
          milestoneId: milestone.milestoneId,
          milestoneIndex: milestone.milestoneIndex,
          feedCurveMilestoneId: milestone.feedCurveMilestoneId,
          total: timesDay.amount,
          addDay:
            <Button
              onClick={() => {
                setFeedPlans(oldFeedPlans => {
                  const feedPlan = [...oldFeedPlans[indexMilestone]];
                  feedPlan.push({day: (timesDay.day)+1, timeId: 0, amount: 0, feedPlanEntryId: 0})
                  const oldFeedPlanCopy = [...oldFeedPlans]
                  oldFeedPlanCopy[indexMilestone]=feedPlan
                  return [...oldFeedPlanCopy];
                })
              }}
              startEnhancer={glyphs.Add({fillColor: colors.greyDarkSecondary, size: "10px"})}
              content=""
              buttonType={ButtonTypes.textButton}
              overrides={{startEnhancerStyles: {margin: "0px"}, contentStyles: {color: colors.greyDarkPrimary}, baseButton: {visibility: timesDay.day !== Math.max(...array.map((entry) => (entry.day))) || day === (milestone.feedPlan!.lastMilestoneDay + (indexMilestone === 0 ? 0 : firstDayOffsetTracker))  ? "hidden" : "visible"}}}
            />,
          })
      })
      indexMilestone === 0 ? firstDayOffsetTracker = milestone.feedPlan.lastMilestoneDay + 1 : firstDayOffsetTracker += milestone.feedPlan.lastMilestoneDay + 1;
    });
  return sparseFeedTimesData;
}